__turbopack_context__.v({
  "button": "home-module-scss-module__9HOn0q__button",
  "description": "home-module-scss-module__9HOn0q__description",
  "homeWrp": "home-module-scss-module__9HOn0q__homeWrp",
  "intro": "home-module-scss-module__9HOn0q__intro",
  "introAnimationContainer": "home-module-scss-module__9HOn0q__introAnimationContainer",
  "introAnimationShadow": "home-module-scss-module__9HOn0q__introAnimationShadow",
  "introContent": "home-module-scss-module__9HOn0q__introContent",
  "introPattern": "home-module-scss-module__9HOn0q__introPattern",
  "supportDescription": "home-module-scss-module__9HOn0q__supportDescription",
  "supportHeading": "home-module-scss-module__9HOn0q__supportHeading",
  "supportPattern": "home-module-scss-module__9HOn0q__supportPattern",
  "supportStamp": "home-module-scss-module__9HOn0q__supportStamp",
  "supportTitle": "home-module-scss-module__9HOn0q__supportTitle",
  "supportWrp": "home-module-scss-module__9HOn0q__supportWrp",
  "title": "home-module-scss-module__9HOn0q__title",
});
